<template>
  <div class="wrapper">
    <highcharts v-if="chartData!=null" :options="chartData" ref="chartComponent"></highcharts>
  </div>
</template>

<script>
import {Chart} from 'highcharts-vue'
import Highcharts from "highcharts";
// import exportingInit from "highcharts/modules/exporting";

import Annotation from 'highcharts/modules/annotations'
Annotation(Highcharts)

import {mapState} from "vuex";

// exportingInit(Highcharts);

export default {
  name: 'DriversScatterChartWidget',

  components: {
    highcharts: Chart
  },

  props: {
    widgetData: Object
  },


  data() {
    return {
      chartOptions: null,
      chartsDTO: null
    }
  },

  computed: {
    ...mapState(['chartRedrawCounter', 'selectedDriver']),

    chartData() {

      if(this.chartsDTO) {
        if(this.selectedDriver==='none') {
          return JSON.parse( this.chartsDTO.chartJSON )
        }
        return JSON.parse( this.chartsDTO.driverCharts[this.selectedDriver] )
      }

      return {}
    }
  },

  methods: {
    requestData(requester) {
      requester.addChartRequest(this.dataCallback, this.widgetData.extname);
    },

    dataCallback(dto) {
      this.chartsDTO = dto
    }

  },

  watch: {
    chartRedrawCounter: function () {
      if(this.$refs.chartComponent && this.$refs.chartComponent.chart) {
        this.$refs.chartComponent.chart.reflow()
      }
    }
  }

}
</script>

<style scoped>
.wrapper {
}
</style>
